//# sourceMappingURL=my-marked-dates.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module chunks = 4